import Head from 'next/head';
import { useRouter } from 'next/router';
import { SEOProps } from '@/lib/seoData';

const SEO = ({ seo }: { seo: SEOProps }) => {
  const router = useRouter();
  const canonicalUrl = `https://dailypolished.com${router.asPath}`;
  if (seo.disable) {
    return (
      <Head>
        {/* Primary Meta Tags */}
        <title>{seo.title}</title>
        <meta name="title" content={seo.title} />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="Daily Polished" />
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Head>
    )
  }
  return (
    <Head>
      {/* Primary Meta Tags */}
      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="author" content="Daily Polished" />
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.openGraphImageUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="dailypolished.com" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta name="twitter:site" content="@PolishedDaily" />
      <meta name="twitter:creator" content="@PolishedDaily" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.twitterImageUrl} />
    </Head>
  );
};

export default SEO;
